module.exports = __webpack_public_path__ + "static/media/level5.9739924a.png";